import FilterProvider from 'providers/Filter';
import PredictionFilterContainer from 'components/organisms/PredictionFilterContainer';
import PredictionGridChromatographicContainer from 'components/organisms/PredictionGridChromatographicContainer';
import PredictionGridChemicalPhysicalContainer from 'components/organisms/PredictionGridChemicalPhysicalContainer';
import React from 'react';
import dayjs from 'dayjs';

const PredictionPresentation = () => {
  const initialState = React.useMemo(
    () => ({
      initialDate: [
        {
          label: dayjs().startOf('year'),
          value: dayjs().startOf('year').toISOString(),
        },
      ],
      finalDate: [
        {
          label: dayjs().endOf('month'),
          value: dayjs().endOf('month').toISOString(),
        },
      ],
    }),
    [],
  );

  return (
    <>
      <FilterProvider initialState={initialState}>
        <PredictionFilterContainer />
        <PredictionGridChromatographicContainer />
        <PredictionGridChemicalPhysicalContainer />
      </FilterProvider>
    </>
  );
};

export default PredictionPresentation;
